import React, { createContext, useContext, useEffect, useState } from "react";

const LANG_KEY = "pd_lang";

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
  { code: "te", label: "Telugu", native: "తెలుగు" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "bn", label: "Bengali", native: "বাংলা" },
];

const T = {
  en: {
    "nav.names": "1008 Names", "nav.verse": "Daily Verse", "nav.pilgrimage": "Cambodia Yatra",
    "nav.donate": "Seva", "nav.club": "Blessing Club", "nav.about": "About",
    "nav.book": "Book Pilgrimage", "nav.signin": "Sign in", "nav.dashboard": "My Dashboard", "nav.admin": "Admin", "nav.logout": "Logout",
    "hero.subtitle": "Pancham Dham · Cambodia",
    "hero.title.1": "Walk the sacred path of the", "hero.title.highlight": "1008 Names", "hero.title.2": "of Shiva.",
    "hero.copy": "A living devotional portal — chant the Sahasranama, witness darshan at Pancham Dham in Cambodia, and offer seva from anywhere in the world.",
    "hero.chant": "Begin Chanting", "hero.yatra": "Book Yatra",
    "stat.names": "Sacred Names", "stat.dhams": "Pancham Series", "stat.verses": "Daily Verses",
    "pillars.title": "Chant · Journey · Offer", "pillars.sub": "The Three Pillars",
    "pillars.copy": "Three sacred paths — pick one, or walk them all.",
    "aarti.live": "Live Aarti", "aarti.offline": "Not streaming right now",
    "share.heading": "Share this blessing",
    "verse.of_day": "Verse of the Day",
  },
  hi: {
    "nav.names": "१००८ नाम", "nav.verse": "नित्य श्लोक", "nav.pilgrimage": "कम्बोडिया यात्रा",
    "nav.donate": "सेवा", "nav.club": "आशीर्वाद मंडल", "nav.about": "परिचय",
    "nav.book": "यात्रा बुक करें", "nav.signin": "प्रवेश करें", "nav.dashboard": "मेरा डैशबोर्ड", "nav.admin": "व्यवस्थापक", "nav.logout": "निकास",
    "hero.subtitle": "पञ्चम धाम · कम्बोडिया",
    "hero.title.1": "शिव के", "hero.title.highlight": "१००८ नामों", "hero.title.2": "का पवित्र मार्ग।",
    "hero.copy": "एक जीवंत भक्ति पोर्टल — सहस्रनाम का जाप करें, कम्बोडिया के पञ्चम धाम में दर्शन करें, और कहीं से भी सेवा अर्पित करें।",
    "hero.chant": "जाप प्रारंभ करें", "hero.yatra": "यात्रा बुक करें",
    "stat.names": "पवित्र नाम", "stat.dhams": "पञ्चम श्रृंखला", "stat.verses": "नित्य श्लोक",
    "pillars.title": "जाप · यात्रा · सेवा", "pillars.sub": "तीन स्तम्भ",
    "pillars.copy": "तीन पवित्र मार्ग — एक चुनें, या तीनों पर चलें।",
    "aarti.live": "सीधा आरती", "aarti.offline": "अभी प्रसारण नहीं",
    "share.heading": "यह आशीर्वाद साझा करें",
    "verse.of_day": "आज का श्लोक",
  },
  ta: {
    "nav.names": "௧௦௦௮ நாமங்கள்", "nav.verse": "நாளாந்த சுலோகம்", "nav.pilgrimage": "கம்போடியா யாத்திரை",
    "nav.donate": "சேவை", "nav.club": "ஆசீர்வாத குழு", "nav.about": "எம்மைப் பற்றி",
    "nav.book": "யாத்திரை பதிவு", "nav.signin": "உள்நுழை", "nav.dashboard": "என் டாஷ்போர்டு", "nav.admin": "நிர்வாகி", "nav.logout": "வெளியேறு",
    "hero.subtitle": "பஞ்சம தாம் · கம்போடியா",
    "hero.title.1": "சிவனின்", "hero.title.highlight": "௧௦௦௮ நாமங்களின்", "hero.title.2": "புனித பாதை.",
    "hero.copy": "ஒரு உயிர்த்துடிக்கும் பக்தி தளம் — சகஸ்ரநாமத்தை ஓதுங்கள், கம்போடியாவின் பஞ்சம தாமில் தரிசனம் செய்யுங்கள், எங்கிருந்தும் சேவை செய்யுங்கள்.",
    "hero.chant": "ஓதத் தொடங்குக", "hero.yatra": "யாத்திரை பதிவு",
    "stat.names": "புனித நாமங்கள்", "stat.dhams": "பஞ்சம தொடர்", "stat.verses": "நாளாந்த சுலோகங்கள்",
    "pillars.title": "ஓதல் · யாத்திரை · சேவை", "pillars.sub": "மூன்று தூண்கள்",
    "pillars.copy": "மூன்று புனித பாதைகள் — ஒன்றை தேர்ந்தெடுங்கள், அல்லது எல்லாவற்றிலும் நடவுங்கள்.",
    "aarti.live": "நேரடி ஆரத்தி", "aarti.offline": "இப்போது ஒளிபரப்பு இல்லை",
    "share.heading": "இந்த ஆசீர்வாதத்தைப் பகிர்க",
    "verse.of_day": "இன்றைய சுலோகம்",
  },
  te: {
    "nav.names": "౧౦౦౮ నామాలు", "nav.verse": "నిత్య శ్లోకం", "nav.pilgrimage": "కంబోడియా యాత్ర",
    "nav.donate": "సేవ", "nav.club": "ఆశీర్వాద మండలి", "nav.about": "మా గురించి",
    "nav.book": "యాత్ర బుక్", "nav.signin": "ప్రవేశించండి", "nav.dashboard": "నా డాష్‌బోర్డ్", "nav.admin": "నిర్వాహకుడు", "nav.logout": "నిష్క్రమణ",
    "hero.subtitle": "పంచమ ధామ్ · కంబోడియా",
    "hero.title.1": "శివుని", "hero.title.highlight": "౧౦౦౮ నామాల", "hero.title.2": "పవిత్ర మార్గం.",
    "hero.copy": "ఒక సజీవ భక్తి ద్వారం — సహస్రనామాన్ని జపించండి, కంబోడియాలోని పంచమ ధామ్‌లో దర్శనం చేయండి, ఎక్కడి నుండైనా సేవ అర్పించండి.",
    "hero.chant": "జపం ప్రారంభం", "hero.yatra": "యాత్ర బుక్",
    "stat.names": "పవిత్ర నామాలు", "stat.dhams": "పంచమ శ్రేణి", "stat.verses": "నిత్య శ్లోకాలు",
    "pillars.title": "జపం · యాత్ర · సేవ", "pillars.sub": "మూడు స్తంభాలు",
    "pillars.copy": "మూడు పవిత్ర మార్గాలు — ఒకటి ఎంచుకోండి, లేదా అన్నిటిలో నడవండి.",
    "aarti.live": "ప్రత్యక్ష ఆరతి", "aarti.offline": "ఇప్పుడు ప్రసారం లేదు",
    "share.heading": "ఈ ఆశీర్వాదాన్ని పంచుకోండి",
    "verse.of_day": "నేటి శ్లోకం",
  },
  mr: {
    "nav.names": "१००८ नावे", "nav.verse": "दैनिक श्लोक", "nav.pilgrimage": "कंबोडिया यात्रा",
    "nav.donate": "सेवा", "nav.club": "आशीर्वाद मंडळ", "nav.about": "आमच्याबद्दल",
    "nav.book": "यात्रा नोंद", "nav.signin": "प्रवेश", "nav.dashboard": "माझा डॅशबोर्ड", "nav.admin": "व्यवस्थापक", "nav.logout": "बाहेर पडा",
    "hero.subtitle": "पंचम धाम · कंबोडिया",
    "hero.title.1": "शिवाच्या", "hero.title.highlight": "१००८ नावांचा", "hero.title.2": "पवित्र मार्ग.",
    "hero.copy": "एक जिवंत भक्तिपूर्ण पोर्टल — सहस्रनाम म्हणा, कंबोडियातील पंचम धामात दर्शन घ्या, आणि कुठूनही सेवा अर्पण करा.",
    "hero.chant": "जप सुरू करा", "hero.yatra": "यात्रा नोंदवा",
    "stat.names": "पवित्र नावे", "stat.dhams": "पंचम मालिका", "stat.verses": "दैनिक श्लोक",
    "pillars.title": "जप · यात्रा · सेवा", "pillars.sub": "तीन स्तंभ",
    "pillars.copy": "तीन पवित्र मार्ग — एक निवडा, किंवा सर्वांवर चाला.",
    "aarti.live": "थेट आरती", "aarti.offline": "आता प्रसारण नाही",
    "share.heading": "हा आशीर्वाद शेअर करा",
    "verse.of_day": "आजचा श्लोक",
  },
  bn: {
    "nav.names": "১০০৮ নাম", "nav.verse": "দৈনিক শ্লোক", "nav.pilgrimage": "কম্বোডিয়া যাত্রা",
    "nav.donate": "সেবা", "nav.club": "আশীর্বাদ মণ্ডল", "nav.about": "আমাদের সম্পর্কে",
    "nav.book": "যাত্রা বুক", "nav.signin": "প্রবেশ", "nav.dashboard": "আমার ড্যাশবোর্ড", "nav.admin": "প্রশাসক", "nav.logout": "প্রস্থান",
    "hero.subtitle": "পঞ্চম ধাম · কম্বোডিয়া",
    "hero.title.1": "শিবের", "hero.title.highlight": "১০০৮ নামের", "hero.title.2": "পবিত্র পথ।",
    "hero.copy": "একটি জীবন্ত ভক্তিমূলক পোর্টাল — সহস্রনাম জপ করুন, কম্বোডিয়ার পঞ্চম ধামে দর্শন করুন, যেকোনো জায়গা থেকে সেবা অর্পণ করুন।",
    "hero.chant": "জপ শুরু করুন", "hero.yatra": "যাত্রা বুক",
    "stat.names": "পবিত্র নাম", "stat.dhams": "পঞ্চম ধারা", "stat.verses": "দৈনিক শ্লোক",
    "pillars.title": "জপ · যাত্রা · সেবা", "pillars.sub": "তিন স্তম্ভ",
    "pillars.copy": "তিনটি পবিত্র পথ — একটি বেছে নিন, অথবা সব পথে হাঁটুন।",
    "aarti.live": "সরাসরি আরতি", "aarti.offline": "এখন সম্প্রচার নেই",
    "share.heading": "এই আশীর্বাদ ভাগ করুন",
    "verse.of_day": "আজকের শ্লোক",
  },
};

const Ctx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || "en");

  useEffect(() => { localStorage.setItem(LANG_KEY, lang); }, [lang]);

  const t = (key) => (T[lang] && T[lang][key]) || T.en[key] || key;

  return <Ctx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);
